import { Injectable } from '@angular/core';
import { WorkspaceType } from '../../core/h3ml/state/task-workspace-state';
import { User } from '../../team-apis/otterdam/user';

export interface WorkspaceConfig {
  name: WorkspaceType;
  projectId: number;
  qaGroupId?: string;
  templateId?: string;
  sampleId?: number;
  stepId?: number;
  initialTaskId?: string;
  submissionId?: number;
}

/**
 * This is for sharing the initial inputs we get to a workspace, to make it
 * available via dependency injection. This service should have no dependencies,
 * so that it can be injected anywhere without risking a cyclic dependency.
 */
@Injectable({ providedIn: 'root' })
export class WorkspaceConfigService implements WorkspaceConfig {
  name!: WorkspaceType;
  projectId!: number;
  user!: User;

  /**
   * Note that in the sampling workspace this will be undefined even when it
   * uses a step layout, because `stepId` is not one of the *initial* inputs
   * to the workspace.
   */
  stepId?: number;

  // production
  qaGroupId?: string;
  templateId?: string;

  // sampling
  sampleId?: number;

  // read-only
  initialTaskId?: string;
}
